import client from "../request";

const get = () => {
  return client.get("/deposit_currencies");
};

export default {
  get
};
